RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const BrandingEdit = views.BrandingEdit = Marionette.LayoutView.extend({
        template: '#settingsBrandingModalTemplate',

        regions: {
            preview: '.x-preview'
        },

        ui: {
            modal: '.modal',
            fileUpload: '.x-file-upload',
            uploadLoading: '.x-custom-logo-load',
            logo: '.x-brand-logo img',
            logoMsg: '.x-custom-logo',
            uploadErrorMsg: '.x-upload-error-msg',
            fileTypeErrorMsg: '.x-file-type-error-msg',
            save: '.x-save'
        },

        events: {
            'click .x-file-upload-btn': 'openFileUploadClicked',
            'click @ui.save': 'save'
        },

        modelEvents: {
            'change:logo': 'setSaveState'
        },

        onBeforeShow: function () {
            const me = this;

            me.setSaveState();
            me.showPreview();
            RivalIQ.execute('tracking:push:auth', me.model.get('usageEvent'));
        },

        setSaveState: function () {
            const me = this;
            me.ui.save.prop('disabled', !me.model.get('logo'));
        },

        onAttach: function () {
            const me = this;
            me.buildFileUpload();
        },

        showPreview: function () {
            const me = this;
            me.preview.show(new App.views.Preview({
                model: me.model,
                landscape: {
                    id: RivalIQ.state.view.get('landscapeId'),
                    name: RivalIQ.state.view.get('landscapeName')
                },
                focusCompany: RivalIQ.state.landscape.getFocusCompany()
            }));
        },

        openFileUploadClicked: function () {
            const me = this;
            me.$('input[type="file"]').click();
        },

        buildFileUpload: function () {
            const me = this;
            const landscapeId = RivalIQ.state.view.get('landscapeId');

            me.ui.fileUpload.fileupload({
                url: me.model.getLogoPath(landscapeId),
                dataType: 'json',
                add: _.bind(me.onFileAdd, me),
                done: _.bind(me.onFileUploadDone, me),
                fail: _.bind(me.onFileUploadFailed, me),
                start: _.bind(me.onFileUploadStart, me)
            });
        },

        onFileAdd: function (event, data) {

            const me = this;
            let isValid = false;
            const file = _.get(data, ['files', 0]);

            if ((/\.(png|gif|jpeg|jpg)$/i).test(_.get(file, 'name'))) {

                isValid = true;
                data.submit();
            }

            me.ui.fileTypeErrorMsg.toggleClass('display-none', isValid);
        },

        onFileUploadStart: function () {
            const me = this;
            me.ui.uploadErrorMsg.hide();
            me.ui.uploadLoading.width(me.ui.logo.width()).show();
        },

        onFileUploadDone: function (e, data) {
            const me = this;

            const version = data.result.version;
            const sizedLogoPath = [me.model.getLogoPath(), version, 'medium'].join('/');

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.PPTThemeUploadLogo);

            const image = new Image();
            image.onload = function () {
                me.ui.uploadLoading.hide();
                me.ui.logo.attr('src', sizedLogoPath);
                me.ui.logoMsg.hide();
                me.model.set('logo', sizedLogoPath);
            };

            image.src = sizedLogoPath;
        },

        onFileUploadFailed: function () {
            const me = this;
            me.ui.uploadLoading.hide();
            me.ui.uploadErrorMsg.show();
        },

        save: function () {
            const me = this;

            me.ui.save.button('loading');

            me.model.save().done(function () {
                RivalIQ.state.branding.setActive(me.model);
                me.ui.modal.modal('hide');
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.PPTThemeSaved);
        }

    });

    views.BrandingItem = Marionette.LayoutView.extend({
        template: '#settingsBrandingItemTemplate',
        className: 'col-md-3 col-sm-4 col-xs-6',

        behaviors: {
            AttributeBuilder: {}
        },

        regions: {
            preview: '.x-branding-preview'
        },

        events: {
            'click .x-branding-preview, .active-branding-label': 'onBrandingClick',
            'click .x-edit': 'onEditClick',
            'click .x-delete': 'onDeleteClick',
            'click .x-revert': 'onRevertClick'
        },

        modelEvents: {
            'sync': 'render',
            'destroy': 'render'
        },

        onRender: function () {
            const me = this;

            me.preview.show(new RivalIQ.views.Branding({
                model: me.model
            }));
        },

        templateHelpers: function () {
            const me = this;

            return {
                canRevert: me.model.get('canRevert') && !me.model.isDefault()
            };
        },

        onBrandingClick: function () {
            const me = this;

            if (!me.model.get('active')) {
                RivalIQ.state.branding.setActive(me.model);
            }
        },

        onEditClick: function () {
            const me = this;
            App.execute('show:modal', new BrandingEdit({
                model: me.model
            }));
        },

        onDeleteClick: function () {
            const me = this;
            RivalIQ.execute('show:modal', new App.views.DeleteCustomBrandingModal({
                model: me.model
            }));
        },

        onRevertClick: function () {
            const me = this;
            RivalIQ.execute('show:modal', new App.views.RevertDefaultBrandingModal({
                model: me.model
            }));
        }
    });

    const Creator = Marionette.ItemView.extend({
        template: '#settingsBrandingCreatorTemplate',
        events: {
            'click .btn': 'onClick'
        },

        onClick: function () {
            const me = this;
            App.execute('show:modal', new BrandingEdit({
                model: me.model
            }));
        }
    });

    views.Branding = Marionette.LayoutView.extend({
        template: '#settingsBrandingTemplate',

        regions: {
            brandingList: {
                selector: '.x-branding-items',
                regionClass: Marionette.Region.extend({
                    attachHtml: function (view) {
                        this.$el.prepend(view.$el);
                    }
                })
            },
            creator: '.x-creator'
        },

        collectionEvents: {
            'remove': 'showCreator',
            'add': 'showCreator'
        },

        onBeforeShow: function () {
            const me = this;

            me.brandingList.show(new Marionette.CollectionView({
                collectionEvents: {
                    'change:active': 'render'
                },
                childView: views.BrandingItem,
                collection: me.collection
            }));

            me.showCreator();
        },

        showCreator: function () {
            const me = this;

            if (me.collection.length !== 1) {
                return me.creator.reset();
            }

            me.creator.show(new Creator({
                model: new RivalIQ.models.Brand.create(RivalIQ.utils.branding.types.CUSTOM, {
                    active: false,
                    logo: null
                })
            }));
        }
    });
});
